import type { SessionInfo } from '@sahab/contracts'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { mustChangePasswordRedirect } from '../app/guards'
import { sessionQueryOptions } from '../features/auth/session'
import { AppLayout } from '../features/shell/app-layout'
import { isApiError } from '../lib/api'

/**
 * Everything behind sign-in. No session → /login, remembering where the user was going. A user who
 * must change their password can only reach the change-password page until they do.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    let session: SessionInfo
    try {
      session = await context.queryClient.ensureQueryData(sessionQueryOptions)
    } catch (error) {
      if (isApiError(error) && error.status === 401) {
        throw redirect({ to: '/login', search: { redirect: location.href }, replace: true })
      }
      throw error
    }
    if (mustChangePasswordRedirect(session, location.pathname)) {
      throw redirect({ to: '/change-password', replace: true })
    }
    return { session }
  },
  component: AppLayout,
})
